import { apiFetch } from '../lib/api';

export const checkUserCredits = async () => {
  try {
    const response = await apiFetch('/api/credits/balance');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Errore nel controllo crediti:', error);
    return { success: false, error: error.message };
  }
};

export const deductCredits = async (amount, description, modelId) => {
  try {
    const response = await apiFetch('/api/credits/deduct', {
      method: 'POST',
      body: JSON.stringify({ amount, description, modelId }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Errore nella deduzione crediti:', error);
    return { success: false, error: error.message };
  }
};

export const getCreditHistory = async () => {
  try {
    const response = await apiFetch('/api/credits/history');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Errore nel recupero storico crediti:', error);
    return { success: false, error: error.message };
  }
};
